// extracted by mini-css-extract-plugin
export default {"formSuccess":"ChangePasswordScreen_formSuccess__sVDsE"};